<template lang="pug">
  div.form-group(:class="fgClass")
    label {{ labelText }}
      i.form-sign-attribute-required(v-if="required") *
    slot
    error-help-block(:message="errorMessage")
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ErrorHelpBlock from './ErrorHelpBlock.vue';

@Component({
  name: 'guest-form-group',
  components: {
    ErrorHelpBlock,
  },
})
export default class GuestFormGroup extends Vue {
  @Prop({ default: false })
  hasError!: boolean

  @Prop({ default: '' })
  labelText!: string

  @Prop({ default: false })
  required!: boolean

  @Prop({ default: '' })
  errorMessage!: string | boolean

  get fgClass() {
    return {
      'has-error': this.hasError,
    };
  }

  get showError(): boolean {
    return this.hasError
        && (typeof this.errorMessage === 'string')
        && ((this.errorMessage as string).length > 0);
  }
}
</script>

<style scoped lang="less">
.form-sign-attribute-required {
  color: red;
  font-style: normal;
  margin-left: 5px;
}
</style>
